import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLocalizedString } from "@amzn/aws-marketing-identity-kit-localizations";
function VisibleToOthersBanner() {
    const { t } = useLocalizedString();
    return (_jsxs("div", { className: "flex flex-col gap-1 p-1 px-2 rounded bg-idk-gradient w-full backdrop-blur text-sm", children: [_jsx("span", { className: "font-bold", children: t("Visible to others") }), _jsx("span", { children: t("Fields in this section will be visible to others.") })] }));
}
export default VisibleToOthersBanner;
//# sourceMappingURL=VisibleToOthersBanner.js.map